import { getResponsiveProp, responsive } from '../helpers';
var BOX_SIZING = {
  content: 'content-box',
  border: 'border-box'
};
var HEIGHTS = {
  stretch: 'stretch',
  fill: '100%'
};
export function boxStyle(_ref) {
  var height = _ref.height,
      overflow = _ref.overflow,
      sizing = _ref.sizing;
  return [{
    boxSizing: sizing && BOX_SIZING[sizing],
    height: height && HEIGHTS[height],
    overflow: overflow
  }, responsiveBoxDisplayStyle];
}

function responsiveBoxDisplayStyle(_ref2) {
  var display = _ref2.display,
      theme = _ref2.theme;
  return responsive(theme.sanity.media, getResponsiveProp(display).map(function (val) {
    return {
      '&:not([hidden])': {
        display: val
      }
    };
  }));
}